import { Component, Input, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import {
  CustomDetailComponent,
  SharedModule,
  TypedBaseListComponent,
} from '@vendure/admin-ui/core'
import { Observable } from 'rxjs'
import { getEmploymentList } from './customer-employment-list.graphql'

@Component({
  selector: 'customer-employment-list',
  templateUrl: './customer-employment-list.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class CustomerEmploymentListComponent
  extends TypedBaseListComponent<typeof getEmploymentList, 'employments'>
  implements CustomDetailComponent, OnInit
{
  @Input() customerId: string
  entity$: Observable<any>
  detailForm: FormGroup

  customFields = this.getCustomFieldConfig('Employment')
  readonly filters = this.createFilterCollection()
    .addFilter({
      name: 'role',
      type: { kind: 'text' },
      label: 'org-hierarchy.role',
      filterField: 'role',
    })
    .addFilter({
      name: 'state',
      type: { kind: 'text' },
      label: 'org-hierarchy.state',
      filterField: 'state',
    })
    .addIdFilter()
    .addDateFilters()
    .addCustomFieldFilters(this.customFields)
    .connectToRoute(this.route)

  readonly sorts = this.createSortCollection()
    .defaultSort('createdAt', 'DESC')
    .addCustomFieldSorts(this.customFields)
    .connectToRoute(this.route)

  constructor() {
    super()
    super.configure({
      document: getEmploymentList,
      getItems: (data) =>
        data.employments ?? {
          totalItems: 0,
          items: [],
        },
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: {
            customerId: { eq: this.customerId },
            ...this.filters.createFilterInput(),
          },
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.filters.valueChanges,
        this.sorts.valueChanges,
      ],
    })
  }

  ngOnInit() {
    super.ngOnInit()
    this.entity$.subscribe((entity) => {
      if (entity?.id && !this.customerId) {
        this.customerId = entity.id
        this.refresh()
      }
    })
  }
}
